import { axiosInstance } from "./axios-instance"
import * as endpoints from "./../constants/api-constants"

class ConcourseService {
  static getWinners(payload) {
    return axiosInstance
      .get(endpoints.concourseWinners + payload)
      .then(resp => resp.data)
  }

  static getPointsSaleCities(payload) {
    return axiosInstance
      .get(endpoints.pointsSaleCities + payload)
      .then(resp => resp.data)
  }

  static getPointsSaleOfCity(payload) {
    return axiosInstance
      .get(endpoints.pointsSaleOfCity + payload)
      .then(resp => resp.data)
  }

  static postCompetitionRedeem(payload, config) {
    return axiosInstance
      .post(endpoints.competitionRedeem, payload, config)
      .then(resp => resp.data)
  }
}

export default ConcourseService
